import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BootstrapAthletePhotosComponent } from './components/bootstrap-athlete-photos/bootstrap-athlete-photos.component';

const routes: Routes = [
  { path: "", component: BootstrapAthletePhotosComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AthletePhotosRoutingModule {}
